// This file was automatically generated from appshared.location.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.location');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.location.stateSelect = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var stateList9735 = opt_data.states;
  var stateListLen9735 = stateList9735.length;
  for (var stateIndex9735 = 0; stateIndex9735 < stateListLen9735; stateIndex9735++) {
    var stateData9735 = stateList9735[stateIndex9735];
    output.append('<option ', (stateData9735 == opt_data.selected) ? 'selected' : '', '>', soy.$$escapeHtml(stateData9735), '</option>');
  }
  if (!opt_sb) return output.toString();
};
